/* @flow */

export default class ApproveInvoiceRequest {
  companyId: number;
  invoiceId: number;
  password: string;
}
